import Utility from "./utility";
class FeedBackForm {

    constructor() {
        this.init();
    }
    init()
    {
        const formWrapper = document.getElementById('feedBackFormWrapper');
        const observer = new MutationObserver((mutationsList, observer) => {
            for (const mutation of mutationsList) {
              if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                for (const addedNode of mutation.addedNodes) {
                  if (addedNode.nodeName === 'IFRAME') 
                  {
                    let mypageRefer = document.querySelector('input[name="field_39395"]') as HTMLInputElement;
                    if (mypageRefer) 
                    {
                        if(document.referrer.indexOf(location.protocol + "//" + location.host) === 0)
                        {
                            let referrerUrl = document.referrer;
                            referrerUrl = referrerUrl? Utility.removeInjectedTags(referrerUrl) : "";
                            mypageRefer.value = referrerUrl;
                            observer.disconnect();
                        }
                    }
                  }
                }
              }
            }
          });
        
        const observerConfig = {
          childList: true,
          subtree:   true,
        };
        observer.observe(formWrapper, observerConfig);
    }

}

export default FeedBackForm;